import { Drawer, Button, Card, Row, Col } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Scrollbars from "react-custom-scrollbars";
import InfiniteScroll from "react-infinite-scroll-component";

const SeatGuestDrawer = ({
  seatGuestDrawerOpen,
  setSeatGuestDrawerOpen,
  transferBill,
  setTransferBill,
  tableList,
  tableCards,
  selectedTable,
  selectedWaitlistGuest,
  selectedTableForSeating,
  setSelectedTableForSeating,
  handleSeatGuestToTable,
  handleTransferBill,
}) => {
  const tableData = tableCards;

  return (
    <Drawer
      open={seatGuestDrawerOpen}
      onClose={() => {
        (setSeatGuestDrawerOpen(false), setTransferBill(false));
      }}
      width="80%"
      styles={{ mask: { backgroundColor: "rgba(0,0,0,0.3)" } }}
      styles={{ body: { padding: "0px", background: "#fff", height: "100%" } }}
      styles={{ header: { display: "none" } }}
    >
      {/* WRAPPER TO HOLD CONTENT + FOOTER */}
      <div style={{ position: "relative", height: "100%", padding: "20px 30px 0" }}>
        {/* Close Icon */}
        <div
          style={{
            position: "absolute",
            right: 30,
            top: 20,
            cursor: "pointer",
            fontSize: 20,
            color: "#444",
            zIndex: 10,
          }}
          onClick={() => {
            (setSeatGuestDrawerOpen(false), setTransferBill(false));
          }}
        >
          <CloseOutlined />
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 5 }}>
          {transferBill ? "Transfer Bill to Another Table" : "Select Table to Seat Guest"}
        </h1>

        <p style={{ color: "#555", marginBottom: 25, fontSize: 14 }}>
          {transferBill ? (
            <>Select an available table to transfer the bill</>
          ) : (
            <>
              Guest Count: <b>{selectedWaitlistGuest?.guests ?? 0}</b> • Showing only available
              tables
            </>
          )}
        </p>

        {/* SCROLLABLE CONTENT */}
        <div
          style={{
            overflowY: "auto",
            height: "calc(100% - 100px)",
            paddingRight: 10,
            paddingBottom: 50,
          }}
        >
          <div
            style={
              !transferBill
                ? {
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                    gap: "20px",
                  }
                : {}
            }
          >
            {transferBill ? (
              <Scrollbars autoHide style={{ height: "73vh" }}>
                <InfiniteScroll
                  dataLength={tableCards.length}
                  hasMore={true}
                  endMessage={
                    <p className="center">
                      <b>Yay! you have seen it all</b>
                    </p>
                  }
                  style={{ overflowX: "hidden" }}
                >
                  <Row gutter={[16, 16]}>
                    {[...tableData]
                      .sort((a, b) => {
                        const extractParts = (name) => {
                          const match = name.trim().match(/^([a-zA-Z\s]+?)(\d+)?$/);
                          return match
                            ? [match[1].trim().toUpperCase(), parseInt(match[2] || 0, 10)]
                            : [name.toUpperCase(), 0];
                        };

                        const [aText, aNum] = extractParts(a.name);
                        const [bText, bNum] = extractParts(b.name);

                        if (aText < bText) return -1;
                        if (aText > bText) return 1;

                        return aNum - bNum;
                      })
                      .map((table) => (
                        <Col key={table.id} xs={24} sm={12} md={12} lg={8} xl={8}>
                          <Card
                            className={`table-card ${table.statusType}`}
                            key={table.cwrFbTableId}
                            onClick={() => setSelectedTableForSeating(table)}
                            style={{
                              borderRadius: "16px",
                              padding: "22px",
                              height: "170px",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              cursor: "pointer",
                              border:
                                selectedTableForSeating?.cwrFbTableId === table.cwrFbTableId
                                  ? "1px solid black"
                                  : "2px solid #E0E0E0",
                            }}
                          >
                            <div
                              style={{ fontSize: "1.2em", fontWeight: 600, marginBottom: "6px" }}
                            >
                              {table.name}
                            </div>
                            <div
                              style={{ fontSize: "1em", fontWeight: 500, marginBottom: "8px" }}
                            >
                              {table.statusType === "ONG" || table.statusType === "OCU"
                                ? "ORDER PLACED"
                                : table.statusType === "STD"
                                ? "SEATED"
                                : table.statusType === "RES"
                                ? "RESERVED"
                                : "AVAILABLE"}
                            </div>
                            {table.statusType === "STD" ||
                              table.statusType === "ONG" ||
                              (table.statusType === "OCU" && (
                                <div
                                  style={{
                                    fontSize: "1.05em",
                                    marginBottom: "8px",
                                    fontWeight: 500,
                                  }}
                                >
                                  👥 {table.noOfPersons ?? 0} / {table.noOfPersons ?? 0}
                                </div>
                              ))}
                            {table.statusType === "OCU" && (
                              <div style={{ fontSize: "1.1em", fontWeight: 600 }}>
                                {table.guestName || ""}
                              </div>
                            )}
                            {table.statusType === "RES" && table.reservedTime && (
                              <div style={{ fontSize: "0.95em", marginTop: "6px" }}>
                                {table.reservedTime}
                              </div>
                            )}
                            {table.statusType === "OCU" && table.time && (
                              <div style={{ fontSize: "0.95em", marginTop: "6px" }}>
                                {table.time}
                              </div>
                            )}
                          </Card>
                        </Col>
                      ))}
                  </Row>
                </InfiniteScroll>
              </Scrollbars>
            ) : (
              <>
                {tableList
                  .filter((tbl) => tbl.statusType === "OPN")
                  .map((tbl) => (
                    <div
                      key={tbl.cwrFbTableId}
                      onClick={() => setSelectedTableForSeating(tbl)}
                      style={{
                        borderRadius: 16,
                        padding: "22px",
                        height: 150,
                        cursor: "pointer",
                        textAlign: "center",
                        background:
                          selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId
                            ? "#DBEAFE"
                            : "#F5F5F5",
                        border:
                          selectedTableForSeating?.cwrFbTableId === tbl.cwrFbTableId
                            ? "3px solid #2563EB"
                            : "2px solid #E0E0E0",
                        transition: "0.2s",
                      }}
                    >
                      <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>
                        {tbl.name}
                      </div>
                      <div style={{ fontSize: 14, color: "#666" }}>AVAILABLE</div>
                    </div>
                  ))}
              </>
            )}
          </div>

          {tableList.filter((tbl) => tbl.statusType === "OPN").length === 0 && (
            <p style={{ textAlign: "center", color: "#888", marginTop: 40 }}>
              No available tables
            </p>
          )}
        </div>

        {/* FIXED FOOTER BUTTONS INSIDE DRAWER */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#fff",
            padding: "15px 30px",
            borderTop: "1px solid #E5E7EB",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            style={{ height: 42, borderRadius: 10, width: "48%" }}
            onClick={() => {
              setSelectedTableForSeating(null);
              setSeatGuestDrawerOpen(false);
              setTransferBill(false);
            }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            disabled={!selectedTableForSeating}
            style={{
              height: 42,
              borderRadius: 10,
              width: "48%",
              fontWeight: 600,
              background: selectedTableForSeating ? "#2F3856" : "#9CA3AF",
            }}
            onClick={() => {
              if (transferBill) {
                handleTransferBill(selectedTable, selectedTableForSeating);
                setSeatGuestDrawerOpen(false);
                setTransferBill(false);
                setSelectedTableForSeating(null);
              } else {
                handleSeatGuestToTable(selectedTableForSeating, selectedWaitlistGuest, "STD");
                setSelectedTableForSeating(null);
              }
            }}
          >
            Confirm Selection
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default SeatGuestDrawer;
